import React, { useEffect, useEffectEvent, useRef, useState } from "react";
import ChatText from "./chat-text";
import { useLanguageStore } from "../../store/languageStore";
import { useNavigationStore } from "src/store/navigationStore";
import useMessagePlayer from "@/hooks/useMessagePlayer";
import AudioPlayer from "../player/audio-player";
import { isIOSMobileBrowser } from "@/utils/device";

interface TextToSpeechProps {
  text: string;
  onFinish?: Function;
  showText?: boolean;
  withAnimation?: boolean;
  audioFile?: string;
}

const TextToSpeech: React.FC<TextToSpeechProps> = ({
  text,
  onFinish,
  showText = true,
  withAnimation = false,
  audioFile = "",
}) => {
  const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);
  const currentRef = useRef("");
  const voiceOn = useLanguageStore((state) => state.voiceOn);
  const currentVoiceSetting = useRef(voiceOn);
  const isInterrupt = useNavigationStore((state) => state.isInterrupt);
  const isLoading = useNavigationStore((state) => state.isLoading);
  const [audioUrl, setAudioUrl] = useState<string>(audioFile);
  const audioMap = useNavigationStore(state => state.audioMap);
  const { readText } = useMessagePlayer();

  const readTextToSpeech = useEffectEvent((toggleVolume: boolean) => {
    readText(text, voiceLanguage, voiceOn, { toggleVolume, onFinish });
  });

  const pollyTTS = (text: string) => {
    // const audio = await tts(text, voiceLanguage);
    const audio = audioMap.get(text);
    if (audio && audioFile === "") {
      setAudioUrl(audio);
    }
  };

  useEffect(() => {
    if (currentRef.current !== text && audioFile === "") {
      currentRef.current = text;
      console.log("isLoading=" + isLoading + ", isInterrupt=" + isInterrupt + ", text=" + text);
      if (!isLoading && !isInterrupt) {
        if (isIOSMobileBrowser()) {
          console.log("fallback to speech synthesis")
          // fallback to window speech synthesis for ios mobile
          readTextToSpeech(false)
        } else {
          pollyTTS(text);
        }
      }
    } else if (currentRef.current !== text && audioFile !== "") {
      setAudioUrl(audioFile);
    }
  }, [text]);

  // controls mute/unmute
  useEffect(() => {
    if (currentVoiceSetting.current !== voiceOn && audioFile === "") {
      currentVoiceSetting.current = voiceOn;
      if (isIOSMobileBrowser()) {
        console.log("fallback to speech synthesis")
        // fallback to window speech synthesis for ios mobile
        readTextToSpeech(true)
      } else {
        pollyTTS(text);
      }

      // readTextToSpeech(true);
    }
  }, [voiceOn]);

  return (
    <>
      {audioUrl && <AudioPlayer audioFile={audioUrl} onFinish={onFinish} />}
      {showText ? (
        <ChatText
          text={text}
          fromChatBot={true}
          useTypeWriter={withAnimation}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default TextToSpeech;
